const APP_NAME = 'variable-rate';

declare global {
  interface Window {
    __lift: {
      experiments: {
        getExperimentHash: (expName: string) => string;
      };
    };
  }
}

/**
 * Creates an experimental URL
 *
 * @param url - The current URL
 * @param expName - Name of the experiment app
 * @param hash - Hash of the experiment
 * @return The experimental URL
 *
 */
function getExperimentalUrl(url: string, expName: string, hash: string) {
  return url.replace(`/${APP_NAME}`, `/static/global/exp/${expName}/${hash}`);
}


/**
  * Redirect to an experimental URL if the experiment exists using Loadlifter to obtain the hash of the experiment.
  * 
  * @remarks
  * This method is part of the {@link https://climate.jira.com/browse/CFVWEB-3742 | Support for experiments effort}.
  * 
  */
export default function experimentRedirection() {
  const hash = window.__lift.experiments.getExperimentHash(APP_NAME);
  if (hash && !window.location.href.includes('exp')) {
    window.location.href = getExperimentalUrl(window.location.href, APP_NAME, hash);
  }
}
